import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyTicketPass = loadable(() => import(/* webpackChunkName: "content/tickets/pass" */ '.'), 'TicketPass');
